/**
 * Created by bartdecorte on 04/05/2017.
 */

const MINIMUM_LENGTH = 16;

const CHARACTER_SETS = {
  lower: 'abcdefghijklmnopqrstuvwxyz',
  upper: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  digit: '0123456789',
  special: '@$!%*#?&.',
};

class Password {
  constructor(params) {
    this.active = false;
    this.params = {
      $element: params.$element,
    };
    this.bindListeners();
  }

  bindListeners() {
    this.params.$element.on('click', '.js-btn-show', (ev) => {
      return this.lButtonShowClicked(ev);
    });
    this.params.$element.on('click', '.js-btn-generate', (ev) => {
      return this.lButtonGenerateClicked(ev);
    });
  }

  lButtonShowClicked(ev) {
    ev.preventDefault();
    this.active = !this.active;
    this.update();
    return false;
  }

  lButtonGenerateClicked(ev) {
    ev.preventDefault();
    let $input = this.params.$element.find('input').first();
    $input.val(Password.random($input.attr('passwordrules')));
    this.active = true;
    this.update();
    $input.get(0).select();
    return false;
  }

  /**
   * Generate a password that satisfies the input's own `passwordrules`
   * attribute, so this stays in step with Password::defaults() server side.
   */
  static random(passwordRules) {
    const { minLength, required } = Password.parseRules(passwordRules);
    const sets = required.length ? required : Object.keys(CHARACTER_SETS);
    const length = Math.max(minLength, MINIMUM_LENGTH);
    const pool = sets.map((set) => CHARACTER_SETS[set]).join('');

    // Seed with one character per required set so the result can never miss one,
    // then shuffle to keep those characters away from fixed positions.
    let characters = sets.map((set) => Password.pick(CHARACTER_SETS[set]));

    while (characters.length < length) {
      characters.push(Password.pick(pool));
    }

    return Password.shuffle(characters).join('');
  }

  /**
   * Read an Apple `passwordrules` attribute, e.g.
   * 'minlength: 10; required: lower; required: upper; required: digit;'
   */
  static parseRules(passwordRules) {
    let minLength = 0;
    let required = [];

    (passwordRules || '').split(';').forEach((rule) => {
      const [key, value] = rule.split(':').map((part) => part.trim().toLowerCase());

      if (key === 'minlength') {
        minLength = parseInt(value, 10) || 0;
      } else if (key === 'required' && CHARACTER_SETS[value]) {
        required.push(value);
      }
    });

    return { minLength, required };
  }

  static pick(characters) {
    return characters.charAt(Password.randomInt(characters.length));
  }

  /**
   * Rejection sampling, because taking a random byte modulo the set size would
   * make the first `256 % size` characters more likely than the rest.
   */
  static randomInt(size) {
    const bytes = new Uint8Array(1);
    const limit = 256 - (256 % size);

    do {
      window.crypto.getRandomValues(bytes);
    } while (bytes[0] >= limit);

    return bytes[0] % size;
  }

  static shuffle(items) {
    for (let i = items.length - 1; i > 0; i--) {
      const j = Password.randomInt(i + 1);
      [items[i], items[j]] = [items[j], items[i]];
    }

    return items;
  }

  update() {
    let $button = this.params.$element.find('.js-btn-show').first();
    let $input = this.params.$element.find('input').first();
    let replacementClass = 'fe fe-eye' + (this.active ? '-off' : '');
    $button
      .find('i')
      .first()
      .attr('class', replacementClass);
    $input.attr('type', this.active ? 'text' : 'password');
  }
}

export default Password;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/Password.js